import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { tryParseInt } from '@/utils/number';

export const viewEditRoute: RouteConfig = {
  path: ':viewId',
  name: 'viewEdit',
  component: () => import(/* webpackChunkName: "ViewEdit" */ '@/views/mainRoute/view/Edit.vue'),
  props: { edit: true },
  meta: {
    breadcrumb: { title: 'Edycja' }
  },
  beforeEnter: (to, from, next) => {
    store.commit('view/setId', tryParseInt(to.params.viewId));
    Promise.all([
      store.dispatch('view/list', { count: -1 }),
      store.dispatch('view/get'),
      store.dispatch('schema/list', { count: -1 })
    ]).then(() => next());
  }
};
